var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import styled from "styled-components";
import { bonfireGet } from "../../../theme";
import Dropdown from "../../Menu/Dropdown/Dropdown";
import GlobalNavMenuItem from "./GlobalNavMenuItem";
var StyledDropdown = styled(Dropdown)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 15px 25px 25px;\n\n  & .bn-nav-menu-content {\n    max-height: 259px;\n    overflow-y: auto;\n  }\n\n  & .bn-nav-menu-title {\n    font-weight: bold;\n    border-bottom: 1px solid ", ";\n    pointer-events: none;\n  }\n  & .bn-nav-menu-title:active,\n  & .bn-nav-menu-title:hover,\n  & .bn-nav-menu-title:focus {\n    background-color: ", ";\n  }\n"], ["\n  padding: 15px 25px 25px;\n\n  & .bn-nav-menu-content {\n    max-height: 259px;\n    overflow-y: auto;\n  }\n\n  & .bn-nav-menu-title {\n    font-weight: bold;\n    border-bottom: 1px solid ", ";\n    pointer-events: none;\n  }\n  & .bn-nav-menu-title:active,\n  & .bn-nav-menu-title:hover,\n  & .bn-nav-menu-title:focus {\n    background-color: ", ";\n  }\n"])), bonfireGet("colors", "surfaceAccent"), bonfireGet("colors", "backgroundLight"));
var GlobalNavMenu = function (props) {
    var children = props.children, title = props.title;
    return (React.createElement(StyledDropdown, __assign({}, props),
        title && children && (React.createElement(GlobalNavMenuItem, { className: "bn-nav-menu-title" }, title)),
        React.createElement("div", { className: "bn-nav-menu-content" }, children)));
};
export default GlobalNavMenu;
var templateObject_1;
//# sourceMappingURL=GlobalNavMenu.js.map